import {Component} from '@angular/core';
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {IBaseBlockComponent, IEventBlock, IPlayerProps, IPlayerPropsEvents} from "../../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {actionUpdateEventsStrings} from "../../../../store/actions/user.actions";
import {MimeAnomalyType} from '../block-constants';
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import {take} from "rxjs/operators";
import {isNullOrUndef, isStringBasedJson} from "../../../../common";
import {DialogEventsExplorerComponent} from "../../../events/dialog-events-explorer/dialog-events-explorer.component";
import {DialogJsonEditorComponent, DialogJsonEditorData} from "../../../../components/dialog-json-editor/dialog-json-editor.component";


@Component({
    selector: 'app-block-send-events',
    templateUrl: './block-send-events.component.html',
    styleUrls: ['./block-send-events.component.scss']
})
export class BlockSendEventsComponent extends BlockBaseComponent implements IBaseBlockComponent {
    bindSceneMode = false;
    readOnly = false;
    assignedName = '';
    assignedType: 'RESOURCE' | 'SCENE';

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override preInit() {
        super.preInit();
    }

    dispatchChanges(values) {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'EventCommands',
                value: [{
                    EventCommand: values
                }],
                storePath: `Data[0]`
            }]
        });
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventItemName3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'notification_add',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openEventsExplorerDialog(e, value);
                    }
                },
                // observable: this.storeSelector.getEmpty(),
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "clickEventName",
                storePath: '$.clickEventName'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventItemParam3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'data_object',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openJsonEditorDialog('clickEventParam');
                    }
                },
                name: "clickEventParam",
                storePath: '$.clickEventParam'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventName3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                // observable: this.storeSelector.getEmpty(),
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "selectItemEventName",
                storePath: '$.selectItemEventName'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventParam3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'data_object',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openJsonEditorDialog('selectItemEventParam');
                    }
                },
                name: "selectItemEventParam",
                storePath: '$.selectItemEventParam'
            }
        ];
    }

    dispatchEventsAll() {
        const eventsAll = [];
        if (this.sceneItem?.$?.selectItemEventName)
            eventsAll.push(this.sceneItem.$.selectItemEventName);
        if (this.sceneItem?.$?.clickEventName)
            eventsAll.push(this.sceneItem.$.clickEventName);
        this.storeSelector.dispatch(actionUpdateEventsStrings({eventsStrings: eventsAll}));
    }

    override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
        super.initApplyStoreToDynamic(applyStoreToDynamic);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        if (this.handleMimeAnomalies() == 'JSON') {
            this.setUiConfigHide('selectItemEventName', false);
            this.setUiConfigHide('selectItemEventParam', false);
        } else {
            this.setUiConfigHide('selectItemEventName', true);
            this.setUiConfigHide('selectItemEventParam', true);
        }
        super.componentStoreUpdates();
        this.configureSendParams();
        super.initApplyStoreToDynamic(true);

    }

    configureSendParams() {
        const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);
        this.assignedName = '';
        this.assignedType = null;
        if (
            playerId === this.blockLabelRecords.JSON_PLAYER.id ||
            playerId === this.blockLabelRecords.JSON_VIEWER.id ||
            playerId === this.blockLabelRecords.BUTTON.id ||
            playerId === this.blockLabelRecords.SVG.id ||
            playerId === this.blockLabelRecords.IMAGE.id ||
            playerId === this.blockLabelRecords.VIDEO.id ||
            playerId === this.blockLabelRecords.LABEL.id
        ) {
            this.bindSceneMode = true;
            if (this.sceneItem?.$?.clickEventParam && isStringBasedJson(this.sceneItem.$.clickEventParam)) {
                try {
                    const p = JSON.parse(this.sceneItem.$.clickEventParam);
                    this.onShowName(p);
                } catch (e) {
                    // Invalid JSON, ignore
                }
            }
        } else {
            this.bindSceneMode = false;
        }
    }

    openEventsExplorerDialog(e, value) {
        const data: IEventBlock = {
            eventName: value.name,
            eventBlockId: this.sceneItemId,
            blockName: this.sceneItem.$.label,
            eventSceneId: this.sceneId,
            eventType: '',
            sceneName: ''
        };
        const dialogRefVal = this.dialog.open(DialogEventsExplorerComponent, {
            height: '85%',
            width: '70%',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: IEventBlock) => {
                    if (!result) return;
                    this.submit(this.getEventsJsonData(result.eventName));
                })
        );
    }

    openJsonEditorDialog(fieldName: string) {
        const currentValue = this.form?.value?.[fieldName] || '';
        const data: DialogJsonEditorData = {
            json: currentValue,
            title: this.translocoService.translate('general.editJson', {}, this.translocoService.getActiveLang())
        };
        const dialogRefVal = this.dialog.open(DialogJsonEditorComponent, {
            height: '70%',
            width: '60%',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: string) => {
                    if (result === undefined || result === null) return;
                    this.setFormValue(fieldName, result);
                    this.submit(this.form.value);
                })
        );
    }

    private getEventsJsonData(i_clickEventName = null, i_clickEventParam = null, i_selectItemEventName = null, i_selectItemEventParam = null): IPlayerPropsEvents {
        const m_clickEventName = !isNullOrUndef(i_clickEventName) ? i_clickEventName : this.sceneItem.$.clickEventName;
        const m_clickEventParam = !isNullOrUndef(i_clickEventParam) ? i_clickEventParam : this.sceneItem.$.clickEventParam;
        const m_selectItemEventName = !isNullOrUndef(i_selectItemEventName) ? i_selectItemEventName : this.sceneItem.$.selectItemEventName;
        const m_selectItemEventParam = !isNullOrUndef(i_selectItemEventParam) ? i_selectItemEventParam : this.sceneItem.$.selectItemEventParam;
        return {
            clickEventName: m_clickEventName,
            clickEventParam: m_clickEventParam,
            selectItemEventName: m_selectItemEventName,
            selectItemEventParam: m_selectItemEventParam
        };
    }

    override submit(formValues) {
        // formValues = removeUndefNulls(formValues);
        // Handle clickEventParam validation and formatting
        if (formValues.clickEventParam) {
            const param = formValues.clickEventParam;

            // 1. If valid JSON, nothing to do
            if (!isStringBasedJson(param)) {
                // Not JSON, it's a plain string
                if (param.includes(' ')) {
                    // 3. String with spaces - must be in format "xxx" with allowed chars (a-z A-Z 0-9 _ - space)
                    if (param.startsWith('"') && param.endsWith('"')) {
                        // Already quoted - clean the inner content
                        const inner = param.slice(1, -1);
                        const cleanedInner = inner.replace(/[^a-zA-Z0-9_\- ]/g, '');
                        formValues.clickEventParam = `"${cleanedInner}"`;
                    } else {
                        // Not quoted - clean and wrap in quotes
                        const cleaned = param.replace(/[^a-zA-Z0-9_\- ]/g, '');
                        formValues.clickEventParam = `"${cleaned}"`;
                    }
                } else {
                    // 2. String without space - only allow a-z A-Z 0-9 _
                    formValues.clickEventParam = param.replace(/[^a-zA-Z0-9_]/g, '');
                }
            }
        }
        const formData = this.getEventsJsonData(
            formValues.clickEventName,
            formValues.clickEventParam,
            formValues.selectItemEventName,
            formValues.selectItemEventParam
        );
        return super.submit(formData);
    }

    private handleMimeAnomalies(): MimeAnomalyType {
        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.CART.id: {
                return 'JSON';
            }
            case this.blockLabelRecords.JSON_PLAYER.id: {
                return 'JSON';
            }
            default: {
                return null;
            }
        }
    }

    onShowName(jData) {
        switch (jData.type) {
            case 'resource': {
                this.cod(
                    this.storeSelector.getResource(jData.id)
                        .pipe(take(1))
                        .subscribe((v) => {
                            this.assignedName = v?.resource_name;
                            this.assignedType = 'RESOURCE';
                        })
                );
                break;
            }
            case 'scene': {
                this.cod(
                    this.storeSelector.getScene(jData.id)
                        .pipe(take(1))
                        .subscribe((v) => {
                            this.assignedName = v?.Player?.$?.label;
                            this.assignedType = 'SCENE';
                        })
                );
                break;
            }
        }
    }

    onClearInput() {
        this.setFormValue('clickEventParam', '');
        this.submit(this.form.value);
    }

    openSceneAssignmentDialog() {
        const data: IDialogGetAsset = {mode: "SCENE_RESOURCE_NOLIB", mimeType: SceneMimeTypes.Player};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            height: '85%',
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: IDialogGetAsset) => {
                    if (!result) return;
                    switch (result.selectedType) {
                        case  "RESOURCE_SELECTED": {
                            const o = {"type": "resource", "id": Number(result.sourceData.resource_id)};
                            this.setFormValue('clickEventParam', JSON.stringify(o));
                            break;
                        }
                        case  "SCENE_SELECTED": {
                            const o = {"type": "scene", "id": Number(result.sourceData.Player.$.id)};
                            this.setFormValue('clickEventParam', JSON.stringify(o));
                            break;
                        }
                    }
                    this.submit(this.form.value);
                })
        );
    }

    override destroy() {
        // Lib.DevShow('porthandler: destroy send events ' + Math.random());
        this.dispatchEventsAll();
        super.destroy();
    }
}

// private handleMimeAnomalies(): MimeAnomalyType {
//     switch (this.sceneItem.$.player) {
//         case this.blockLabelRecords.STOCKS.id: {
//             return 'STOCKS';
//         }
//         case this.blockLabelRecords.XML.id: {
//             return 'XML';
//         }
//         case this.blockLabelRecords.CATALOG.id: {
//             return 'CATALOG';
//         }
//         case this.blockLabelRecords.CUSTOMRSS.id: {
//             return 'CUSTOM_RSS';
//         }
//         default: {
//             const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);
//             switch (playerId) {
//                 case this.blockLabelRecords.NETFEED_NEWS.id: {
//                     return 'NETFEED_NEWS';
//                 }
//                 case this.blockLabelRecords.NETFEED_HOROSCOPE.id: {
//                     return 'NETFEED_HOROSCOPE';
//                 }
//                 default: {
//                     return 'JSON';
//                 }
//             }
//         }
//     }
// }
// this.debouncerFunc = _.debounce(() => {
//     const color = String(Lib.HexToDecimal('000000'));
//     this.dispatchSceneItemChanges({
//         sceneId: this.sceneId,
//         sceneItemId: this.sceneItem.$.id,
//         values: [{
//             key: 'color',
//             value: color,
//             storePath: `Data[0].Foo[0].$`
//         }]
//     });
// }, 100);
// readonly faRightFromBracket = faRightFromBracket;
// debouncerFunc;
// m_clickEventParam = '';
